import { useState } from 'react';
import { Button } from '../../r2/Button';
import styles from './Navbar.module.css';

export interface NavLink {
  label: string;
  href: string;
}

export interface NavbarProps {
  links?: NavLink[];
  onSignUp?: () => void;
}

const defaultLinks: NavLink[] = [
  { label: 'Problem', href: '#problem' },
  { label: 'Solution', href: '#solution' },
  { label: 'About', href: '#about' },
];

export function Navbar({ links = defaultLinks, onSignUp }: NavbarProps) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav data-crd-id="r3.bq-navbar" data-crd-layer="r3" className={styles.navbar} role="banner">
      <div className={styles.container}>
        <a href="/" className={styles.logo}>
          <img
            src="/assets/images/logo-white.png"
            alt=""
            className={styles.logoIcon}
            width={28}
            height={28}
          />
          <span className={styles.logoText}>BlueQueue</span>
        </a>

        <button
          className={styles.hamburger}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
        >
          <span className={styles.hamburgerLine} />
          <span className={styles.hamburgerLine} />
          <span className={styles.hamburgerLine} />
        </button>

        <div className={`${styles.menu} ${menuOpen ? styles.menuOpen : ''}`}>
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={styles.navLink}
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <div className={styles.ctaWrap}>
            <Button variant="primary" size="small" onClick={onSignUp}>
              Sign Up
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
}
